"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useRef, useMemo, useEffect } from 'react';
import { autorun } from 'mobx';
import { getAsyncResource } from '@mittwald/react-use-promise';
import { SettingsStore } from './models/SettingsStore.mjs';
import { settingsBackendFactory } from './backends/settingsBackendFactory.mjs';

const context = createContext(void 0);
const useSettings = () => useContext(context);
const SettingsProvider = (props) => {
  const { children, id, ...storeShape } = props;
  const backend = settingsBackendFactory(storeShape);
  const storedSettingsResource = getAsyncResource(() => backend.load(), [], {
    loaderId: id
  });
  const storedSettings = storedSettingsResource.use();
  const storingPromise = useRef(Promise.resolve());
  const settingsStore = useMemo(
    () => SettingsStore.fromJson(storedSettings),
    [id]
  );
  const watchAndStoreSettings = () => {
    const json = settingsStore.asJson;
    storingPromise.current = storingPromise.current.then(async () => {
      await backend.store(json);
      storedSettingsResource.refresh();
    });
  };
  useEffect(() => autorun(watchAndStoreSettings), [id]);
  return /* @__PURE__ */ jsx(context.Provider, { value: settingsStore, children });
};

export { SettingsProvider, SettingsProvider as default, useSettings };
//# sourceMappingURL=SettingsProvider.mjs.map
